import { getId, isDefined } from 'services/utils'
import { APIDocument, APIImage, Doc, FormImage } from '../entities'
import { CatalogItemBase } from './catalogItemBase/types/internal/catalogItemBase-models'
import { APIProductSection, ProductSection } from './types'

export const productSectionParse = <T extends CatalogItemBase>(
  res: APIProductSection<T>
): ProductSection<T> => ({
  ...res,
  products: res.products.map(getId),
  // in the case of section forms that do not allow adding to a section a product that already has a section assigned
  // we need to pass to the internal model the list of products bound to it to enrich the assignable product choices with its own products
  productsFull: res.products,
})

export const parseImage = (img?: APIImage): FormImage | undefined => {
  if (!img) return undefined

  return {
    id: img.id,
    src: img.url,
  }
}

export const parseDoc = (doc?: APIDocument): Doc | undefined => {
  if (!doc) return undefined

  return {
    id: doc.id,
    src: doc.url,
    title: doc.fileName,
  }
}

export const parseKDocks = (eventKampaayerDocs: APIDocument[]) => {
  return eventKampaayerDocs.map(parseDoc).filter(isDefined)
}
